/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaFileUpdate
 */
export interface MediaFileUpdate {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFileUpdate
     */
    info?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFileUpdate
     */
    customFields?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {number}
     * @memberof MediaFileUpdate
     */
    totalFiles?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileUpdate
     */
    needsRescan?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaFileUpdate
     */
    bookmarkedBy?: Array<number>;
}

export function MediaFileUpdateFromJSON(json: any): MediaFileUpdate {
    return MediaFileUpdateFromJSONTyped(json, false);
}

export function MediaFileUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'info': !exists(json, 'info') ? undefined : json['info'],
        'customFields': !exists(json, 'custom_fields') ? undefined : json['custom_fields'],
        'totalFiles': !exists(json, 'total_files') ? undefined : json['total_files'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'bookmarkedBy': !exists(json, 'bookmarked_by') ? undefined : json['bookmarked_by'],
    };
}

export function MediaFileUpdateToJSON(value?: MediaFileUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'info': value.info,
        'custom_fields': value.customFields,
        'total_files': value.totalFiles,
        'needs_rescan': value.needsRescan,
        'bookmarked_by': value.bookmarkedBy,
    };
}


